<div class="service-pro-user-menu" [class.service-pro-user-menu--overlay]="mapOverlay">
    @if (!mapOverlay) {
        <div class="service-pro-user-menu__content">
            <span class="service-pro-user-menu__user" aria-hidden="true">{{ userInfoData?.works?.name }}</span>
        </div>
    }
    <div class="service-pro-user-menu__actions">
        <button
            #burgerButton
            (click)="toggleMenu(); $event.stopPropagation()"
            class="service-pro-user-menu__burger"
            featureHighlightParent="top-nav-burger"
            [featureHighlightPulse]="!showMenu"
            [attr.aria-expanded]="showMenu"
            [attr.aria-label]="showMenu ? 'Luk brugermenu' : 'Åbn brugermenu'"
            aria-controls="user-dropdown-menu"
            aria-haspopup="menu"
            type="button"
        >
            <mat-icon class="service-pro-user-menu__icon" svgIcon="account-outline" aria-hidden="true"></mat-icon>
        </button>
    </div>

    <menu
        id="user-dropdown-menu"
        role="menu"
        aria-label="Brugerhandlinger"
        [class.menu--open]="showMenu"
        [attr.aria-hidden]="!showMenu"
        [attr.inert]="showMenu ? null : ''"
        (closeMenu)="closeAndFocus()"
    >
        <user-info [data]="userInfoData" featureHighlight="highlight_Info" featureHighlightBadge="inline" />
        @for (item of extraNavItems; track item.route) {
            <a [routerLink]="item.route" role="menuitem" [attr.aria-label]="item.label" (click)="closeAndFocus()">
                <mat-icon class="service-pro-user-menu__icon" [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
                <span>{{ item.label }}</span>
            </a>
        }
        <button
            (click)="toggleThemeSubmenu(); $event.stopPropagation()"
            class="theme-menu-trigger"
            role="menuitem"
            type="button"
            aria-haspopup="true"
            [attr.aria-expanded]="showThemeSubmenu"
            aria-label="Tema"
        >
            <mat-icon class="service-pro-user-menu__icon" svgIcon="menu-theme" aria-hidden="true"></mat-icon>
            <span>Tema</span>
            <mat-icon
                class="service-pro-user-menu__icon theme-menu-trigger__chevron"
                [svgIcon]="showThemeSubmenu ? 'chevron-down' : 'chevron-right'"
                aria-hidden="true"
            ></mat-icon>
        </button>
        @if (showThemeSubmenu) {
            @for (option of themeOptions; track option.mode) {
                <button
                    (click)="selectTheme(option.mode)"
                    class="theme-submenu-item"
                    role="menuitemradio"
                    type="button"
                    [attr.aria-checked]="activeTheme() === option.mode"
                    [attr.aria-label]="option.label"
                >
                    <mat-icon
                        class="service-pro-user-menu__icon theme-submenu-item__check"
                        [class.theme-submenu-item__check--hidden]="activeTheme() !== option.mode"
                        svgIcon="check"
                        aria-hidden="true"
                    ></mat-icon>
                    <span>{{ option.label }}</span>
                </button>
            }
        }
        <button
            (click)="openFeedback()"
            role="menuitem"
            type="button"
            featureHighlight="highlight_Feedback"
            featureHighlightBadge="inline"
            aria-label="Åbn feedback dialog"
        >
            <mat-icon class="service-pro-user-menu__icon" svgIcon="feedback" aria-hidden="true"></mat-icon>
            <span>Feedback</span>
        </button>
        @if (showMenu) {
            @if (teknikerPasswordFeaturesSupported$ | async) {
                <button (click)="onSkiftAdgangskode()" role="menuitem" type="button">
                    <span>Skift adgangskode</span>
                </button>
            }
        }
        <a routerLink="/logout" role="menuitem" aria-label="Log ud af applikationen">
            <mat-icon class="service-pro-user-menu__icon" svgIcon="menu-logout" aria-hidden="true"></mat-icon>
            <span>Log ud</span>
        </a>
    </menu>
</div>
